import { parse } from './helpers';

const rootRoutes = {
  user: {
    path: 'user', // user profile
    title: 'pages.user.title',
    children: {
      // those routes will only be available when user.role === user
      user: { path: 'user', title: 'pages.register.title' },
      business: { path: 'business', title: 'pages.register_business.title' },
    },
  },
  book: {
    path: ':businessSlug/book',
    title: 'pages.book.title',
    children: {
      success: { path: 'success', title: 'pages.booking_success.title' },
    },
  },
  register: {
    title: 'pages.register.title',
    path: ':businessSlug/register',
  },
  auth: {
    path: 'auth',
    children: {
      signIn: { path: 'signin', title: 'pages.sign_in.title' },
      signUp: {
        path: 'signup',
        title: 'pages.sign_up.title',
        children: {
          user: { path: 'user', title: 'pages.sign_up.title' },
          business: { path: 'business', title: 'pages.sign_up_business.title' },
          confirm: { path: 'confirm', title: 'pages.sign_up_confirm.title' },
        },
      },
      resetPassword: { path: 'reset', title: 'pages.reset_password.title' },
      requestNewPassword: { path: 'request', title: 'pages.request_password.title' },
      google: { path: 'confirm-google', title: 'pages.sign_in_google.title' },
    },
  },
  business: {
    path: 'b/:businessId',
    children: {
      schedule: { path: 'schedule', title: 'pages.schedule.title' },
      storage: { path: 'storage', title: 'pages.storage.title' },
      agenda: { path: 'agenda', title: 'pages.agenda.title' },
      addStudent: {
        path: 'add-student',
        title: 'pages.add_student.title',
      },
      editStudent: {
        path: 'edit-student',
        title: 'pages.edit_student.title',
      },
      addInstructor: { path: 'add-instructor', title: 'pages.add_employee.title' },
      cashFlow: {
        path: 'cash-flow',
        title: 'pages.cash_flow.title',
      },
      charges: {
        path: 'charges',
        title: 'pages.charges.title',
      },
      invoices: {
        path: 'invoices',
        title: 'pages.invoices.title',
      },
      checkout: {
        path: 'checkout',
        children: {
          students: { path: 'students', title: 'pages.checkout_students.title' },
          products: { path: 'products', title: 'pages.checkout_products.title' },
          payments: { path: 'payments', title: 'pages.checkout_payment.title' },
        },
      },
      equipment: {
        path: 'equipment',
        title: 'pages.equipment.title',
        children: {
          details: { path: ':equipmentId', title: 'pages.equipment.title' },
        },
      },
      shop: {
        path: 'shop',
        title: 'pages.shop.title',
        children: {
          details: { path: ':shopId', title: 'pages.shop.title' },
        },
      },
      messages: {
        path: 'messages',
        title: 'pages.messages.title',
        children: {
          chat: { path: ':studentId', title: 'pages.messages.title' },
        },
      },
      liveChat: {
        path: 'live-chat',
        title: 'pages.live_chat.title',
        children: {
          conversation: { path: ':publicId', title: 'pages.live_chat_conversation.title' },
        },
      },
      insights: { path: 'insights', title: 'pages.insights.title' },
      lessons: { path: 'lessons', title: 'pages.lessons.title' },
      bookings: { path: 'bookings', title: 'pages.bookings.title' },
      bookingsSettings: { path: 'bookings-settings', title: 'pages.bookings_settings.title' },
      lesson: {
        path: 'lessons/:lessonId',
        title: 'pages.lesson.title',
        children: { logs: { path: 'logs', title: 'pages.lesson_logs.title' } },
      },
      rental: {
        path: 'rentals/:rentalId',
        title: 'pages.rental.title',
        children: { logs: { path: 'logs', title: 'pages.rental_logs.title' } },
      },
      rentals: { path: 'rentals', title: 'pages.rentals.title' },
      students: { path: 'students', title: 'pages.students.title' },
      student: {
        path: 'students/:studentId',
        children: {
          lessons: { path: 'lessons', title: 'pages.student.views.lessons.title' },
          rentals: { path: 'rentals', title: 'pages.student.views.rentals.title' },
          finances: { path: 'finances', title: 'pages.student.views.finances.title' },
          logs: { path: 'logs', title: 'pages.student.views.logs.title' },
        },
      },
      instructors: { path: 'instructors', title: 'pages.instructors.title' },
      instructor: {
        path: 'instructors/:instructorId',
        children: {
          schedule: { path: 'schedule', title: 'pages.employee.schedule.title' },
          history: { path: 'history', title: 'pages.employee.history.title' },
          finances: { path: 'finances', title: 'pages.employee.finances.title' },
          logs: { path: 'logs', title: 'pages.employee.logs.title' },
        },
      },
      settings: {
        path: 'settings',
        children: {
          staff: {
            path: 'staff',
            title: 'pages.settings.staff.title',
            children: { logs: { path: ':userId/logs', title: 'pages.settings.staff.logs.title' } },
          },
          school: { path: 'school', title: 'pages.settings.school.title' },
          pricelist: { path: 'pricelist', title: 'pages.settings.pricelist.title' },
          studentForm: { path: 'student-form', title: 'pages.settings.student_form.title' },
          bookings: { path: 'bookings', title: 'pages.settings.bookings.title' },
          tabletView: { path: 'tablet-view', title: 'pages.settings.tablet_view.title' },
          subscription: { path: 'subscription', title: 'pages.settings.subscription.title' },
          billingDetails: { path: 'billing', title: 'pages.settings.billing.title' },
          paymentProvider: {
            path: 'payment-provider',
            title: 'pages.settings.payment_provider.title',
          },
          developer: { path: 'developer', title: 'pages.settings.developer.title' },
          widget: { path: 'widget', title: 'pages.settings.widget.title' },
          whatsapp: { path: 'whatsapp', title: 'Settings - WhatsApp' },
        },
      },
    },
  },
  student: {
    path: 's',
    children: {
      details: {
        path: ':studentId',
        children: {
          edit: { path: 'edit', title: 'pages.my_account.edit.title' },
          lessons: { path: 'lessons', title: 'pages.my_account.lessons.title' },
          rentals: { path: 'rentals', title: 'pages.my_account.rentals.title' },
          finances: { path: 'finances', title: 'pages.my_account.finances.title' },
        },
      },
    },
  },
  kiosk: {
    path: 'kiosk',
    title: 'pages.kiosk.title',
    children: {
      register: { path: 'register-student', title: 'pages.kiosk.register.title' },
      instructors: {
        path: 'instructors',
        title: 'pages.kiosk.instructors.title',
        children: {
          lessons: {
            path: ':instructorId/lessons',
            title: 'pages.kiosk.instructors.lessons.title',
            children: {
              complete: {
                path: ':lessonId',
                title: 'pages.kiosk.instructors.lessons.complete.title',
              },
            },
          },
        },
      },
    },
  },
  payment: {
    path: 'payment',
    title: 'pages.payment.title',
  },
  _404: {
    path: '404',
  },
} as const;

export default parse(rootRoutes);
